// extracted by mini-css-extract-plugin
module.exports = {"debug":"index-module--debug--1JcJr"};